/** @format */

import {useState} from 'react';

import {Check, Undo} from '@mui/icons-material';
import {Box, Tooltip} from '@mui/material';

import {ActionIcon, NumberCircle, RecommendationText, StyledContainer} from './styles';

interface RecommendationElementProps {
  number: number;
  text: string;
  onClick?: () => void;
  onMarkAsRead?: () => void;
  onRemoveFromSuspends?: () => void;
}

export const RecommendationElement = ({
  number,
  text,
  onClick,
  onMarkAsRead,
  onRemoveFromSuspends,
}: RecommendationElementProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onMarkAsRead) {
      onMarkAsRead();
    } else if (onRemoveFromSuspends) {
      onRemoveFromSuspends();
    }
  };

  const getTooltipText = () => {
    if (onMarkAsRead) return 'Отметить как прочитанное';
    if (onRemoveFromSuspends) return 'Убрать из приостановленных';
    return '';
  };

  const renderIcon = () => {
    if (onMarkAsRead) return <Check sx={{width: 16, height: 16}} />;
    if (onRemoveFromSuspends) return <Undo sx={{width: 16, height: 16}} />;
    return null;
  };

  if (number === 0) {
    return (
      <StyledContainer
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
          <Check sx={{width: 16, height: 16}} />
          <RecommendationText variant='body2'>{text}</RecommendationText>
        </Box>
      </StyledContainer>
    );
  }

  return (
    <StyledContainer
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <NumberCircle>{number}</NumberCircle>
      <Box>
        <RecommendationText variant='body2'>{text}</RecommendationText>
      </Box>
      {(onMarkAsRead || onRemoveFromSuspends) && (
        <Tooltip title={getTooltipText()} placement='top'>
          <ActionIcon
            isVisible={isHovered || Boolean(onRemoveFromSuspends)}
            onClick={handleIconClick}
          >
            {renderIcon()}
          </ActionIcon>
        </Tooltip>
      )}
    </StyledContainer>
  );
};
